export default __webpack_public_path__ + "static/media/ellipse_234.30512dce.png";